module.exports = __webpack_public_path__ + "img/tracing_point2.876e63c1.svg";